import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DialogModule } from 'primeng/dialog';
import { GalleriaModule } from 'primeng/galleria';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InplaceModule } from 'primeng/inplace';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgChartsModule } from 'ng2-charts';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { PickListModule } from 'primeng/picklist';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StepsModule } from 'primeng/steps';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ImageModule } from 'primeng/image';
import { ToolbarModule } from 'primeng/toolbar';
import { OrderListModule } from 'primeng/orderlist';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { ChipsModule } from 'primeng/chips';
import { FileUploadModule } from 'primeng/fileupload';
import { RouterModule } from '@angular/router';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PasswordModule } from 'primeng/password';
import { ProgressBarModule } from 'primeng/progressbar';
import { SplitterModule } from 'primeng/splitter';
import { DragDropModule } from 'primeng/dragdrop';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TimelineModule } from 'primeng/timeline';
import { TreeModule } from 'primeng/tree';
import { EditorModule } from 'primeng/editor';
import { DataViewModule } from 'primeng/dataview';
import { PaginatorModule } from 'primeng/paginator';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AgGridModule } from 'ag-grid-angular';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AuthComponent } from './auth/auth.component';
import { BaseInputFieldComponent2 } from './common/components/dynamic-form-v2/components/base-input-field/base-input-field.component';
import { BaseviewComponent } from './common/components/baseview/baseview.component';
import { YesNoPipe } from './common/pipes/yes-no.pipe';
import { ThumbPathPipe } from './common/pipes/thumbPath.pipe';
import { OfficeTimePipe } from './common/pipes/officeTime.pipe';
import { ConvertToReadablePipe } from './common/pipes/convert-to-readable';
import { OfficeTimeFormPipe } from './common/pipes/officeTimeForm.pipe';
import { Safe } from './common/pipes/safeHtml.pipe';
import { BuildAssetComponent } from './common/components/build-asset/build-asset.component';
import { ManagedListComponent } from './common/components/managed-list/managed-list.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { DynamicFieldComponent } from './dynamic-field/dynamic-field.component';
import { DependentInputComponent } from './common/components/dependent-input/dependent-input.component';
import { FormArrayComponent } from './dynamic-field/control-groups/form-array/form-array.component';
import { FormGroupComponent } from './dynamic-field/control-groups/form-group/form-group.component';
import { ItemBuildsHistoryComponent } from './entities/item/item-buildshistory/item-buildshistory.component';
import { ChallengeBuildsHistoryComponent } from './entities/challenge/challenge-buildshistory/challenge-buildshistory.component';
import { FormCreatorComponent } from './form-creator/form-creator.component';
import { RefSuffixRemovalPipe } from './common/pipes/refString.pipe';
import { CurrencyFormComponent } from './entities/currency/currency-form/currency-form.component';
import { BuildGamedataComponent } from './build-gamedata/build-gamedata.component';
import { TraitTableComponent } from './entities/trait/trait-table/trait-table.component';
import { ArtComponent } from './tools/art/art.component';
import { RenameContentComponent } from './tools/rename-content/rename-content.component';
import { CollectionViewComponent } from './entities/collection/collection-view/collection-view.component';
import { BuildDataComponent } from './build-data/build-data.component';
import { SettingsComponent } from './entities/settings/settings.component';
import { TableDataComponent } from './cms-v2/entities/table-data/components/table-data/table-data.component';
import { FileUplaoderComponent } from './common/components/file-uplaoder/file-uplaoder.component';
import { EntityHistoryComponent } from './common/components/entity-history/entity-history.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { RulesComponent } from './common/components/rules/rules.component';
import { GamedataDiffViewComponent } from './build-gamedata/prod-gamedata-push/gamedata-diff-view/gamedata-diff-view.component';
import { GamedataDiffViewV2Component } from './cms-v2/entities/gamedata-diff-view-v2/gamedata-diff-view-v2.component';
import { GamedataCompareToolComponent } from './build-gamedata/gamedata-compare-tool/gamedata-compare-tool.component';
import { ProdGamedataPushComponent } from './build-gamedata/prod-gamedata-push/prod-gamedata-push.component';
import { ChallengesKeywordsComponent } from './entities/challenge/challenge-keywords/challenge-keyword.component';
import { PrizesCardFormGroupComponent } from './common/components/prizes-card-form-group/prizes-card-form-group.component';
import { GlobalSearchComponent } from './common/components/global-search/global-search.component';
import { DropdownMultiselectComponent } from './common/components/dropdown-multiselect/dropdown-multiselect.component';
import { AdvancedSearchComponent } from './advanced-search/components/advanced-search/advanced-search.component';
import { BuildNodesSettingsComponent } from './entities/settings/components/build-nodes-settings/build-nodes-settings.component';
import { CmsDevSettingsComponent } from './entities/cms-dev-settings/cms-dev-settings.component';
import { NestedEconTableComponent } from './common/components/nested-econ-table/nested-econ-table.component';
import { EconTableComponent } from './entities/econ-table/econ-table.component';
import { BulkBuildDataComponent } from './build-data/components/bulk-build-data/bulk-build-data.component';
import { BulkBuildDataTableComponent } from './build-data/components/bulk-build-data/table/bulk-build-data-table/bulk-build-data-table.component';
import { DynamicFormV2Component } from './common/components/dynamic-form-v2/dynamic-form-v2.component';
import { BaseDynamicFormComponent } from './common/components/dynamic-form-v2/components/base-dynamic-form/base-dynamic-form.component';
import { MultiDropdownSelectComponent } from './common/components/dynamic-form-v2/components/multi-dropdown-select/multi-dropdown-select.component';
import { IconsViewComponent } from './cms-v2/entities/category/components/icons-view/icons-view.component';
import { SeasonPassViewComponent } from './entities/season-pass/season-pass-view.component';
import { SeasonPassTracksFieldComponent } from './cms-v2/entities/season-pass/components/season-pass-tracks-field/season-pass-tracks-field.component';
import { RewardsTrackFormV3Component } from './cms-v2/entities/rewards-track/components/rewards-track-form-v3/rewards-track-form-v3.component';
import { RewardsTrackDynamicFieldComponent } from './cms-v2/entities/rewards-track/components/rewards-track-dynamic-field/rewards-track-dynamic-field.component';
import { RewardsTrackViewComponent } from './cms-v2/entities/rewards-track/components/rewards-track-view/rewards-track-view.component';
import { RestrictionFormFieldComponent } from './cms-v2/entities/restriction/components/restriction-form-fields/restriction-form-field.component';
import { CollectionCustomFieldComponent } from './cms-v2/entities/collection/components/collection-custom-field/collection-custom-field.component';
import { DailyRewardsDynamicFieldComponent } from './cms-v2/entities/daily-rewards/daily-rewards-dynamic-field/daily-rewards-dynamic-field.component';
import { SeasonPassFormTracksCustomFieldComponent } from './cms-v2/entities/season-pass/components/season-pass-form-tracks-custom-field/season-pass-form-tracks-custom-field.component';
import { LoadingScreenImagesComponent } from './cms-v2/entities/loading-screen/components/loading-screen-images/loading-screen-images.component';
import { AssetVersionTableComponent } from './entities/asset-version-table/asset-version-table.component';
import { DynamicViewV2 } from './common/components/dynamic-view-v2/dynamic-view-v2.component';
import { ValidateButtonComponent } from './common/components/validate-button/validate-button.component';
import { ValidationResultsPanelComponent } from './common/components/validation-results-panel/validation-results-panel.component';
import { ValidateEntityComponent } from './common/components/validate-entity/validate-entity.component';
import { PlasticFilesAutocompleteComponent } from './common/components/plastic-files-autocomplete/plastic-files-autocomplete.component';
import { TagsManagedListComponent } from './entities/settings/components/managed-lists/tags-managed-list/tags-managed-list.component';
import { ContentHoldManagedListComponent } from './entities/settings/components/managed-lists/content-hold-managed-list/content-hold-managed-list.component';
import { ChallengeContentHoldManagedListComponent } from './entities/settings/components/managed-lists/challenge-content-hold-managed-list/challenge-content-hold-managed-list.component';
import { CreatureTypeVariantsInlineComponent } from './cms-v2/entities/creature-type/creature-type-variants-inline/creature-type-variants-inline.component';
import { DailyRewardsThemeAssetByDayComponent } from './cms-v2/entities/daily-rewards/daily-rewards-theme-asset-by-day/daily-rewards-theme-asset-by-day.component';
import { DailyGoalDateToAchievementComponent } from './cms-v2/entities/daily-goal/daily-goal-date-to-achievement/daily-goal-date-to-achievement.component';
import { DailyGoalDateToAchievementsComponent } from './cms-v2/entities/daily-goal/daily-goal-date-to-achievements/daily-goal-date-to-achievements.component';
import { QuestionsInlineComponent } from './common/components/questions-inline/questions-inline.component';
import { QuestionsBulkImportComponent } from './common/components/questions-bulk-import/questions-bulk-import.component';
import { AnswersBulkImportComponent } from './common/components/answers-bulk-import/answers-bulk-import.component';
import { CollectionsBulkImportComponent } from './common/components/collections-bulk-import/collections-bulk-import.component';
import { AnimationTriggerMapInputComponent } from './common/components/dynamic-form-v2/components/animation-trigger-map-input/animation-trigger-map-input.component';
import { AnimationTriggerMapViewComponent } from './common/components/dynamic-view-v2/components/animation-trigger-map-view/animation-trigger-map-view.component';
import { NurtureCustomFieldComponent } from './cms-v2/entities/nurture/components/nurture-stage-custom-field/nurture-stage-custom-field.component';
import { RenderPreviewToolComponent } from './tools/art/render-preview-tool/render-preview-tool.component';
import { NufCollectionViewComponent } from './entities/nuf-collection/nuf-collection-view/nuf-collection-view.component';
import { CreateNewAssetComponent } from './common/components/dynamic-table/sub-components/create-new-asset/create-new-asset.component';
import { BulkRenderAssetsComponent } from './common/components/dynamic-table/sub-components/bulk-render-assets/bulk-render-assets.component';
import { BuildHistoryChartComponent } from './build-data/components/build-history-chart/build-history-chart.component';
import { ReleaseTypeCustomFieldComponent } from './cms-v2/entities/release-type/components/release-type-custom-field/release-type-custom-field.component';
import { BuildHistoryComponent } from './common/components/build-history/build-history.component';
import { AssetPopupFormComponent } from './common/components/asset-popup-form/asset-popup-form.component';
import { DynamicListComponent } from './dynamic-list/dynamic-list.component';
import { RenderGalleryComponent } from './common/components/render-gallery/render-gallery.component';
import { AssetRefInputComponent } from './common/components/asset-ref-input/asset-ref-input.component';
import { NurtureItemsInputComponentComponent } from './common/components/nurture-items-input-component/nurture-items-input-component.component';
import { NurtureStagesInputComponent } from './common/components/nurture-stages-input/nurture-stages-input.component';
import { HistoryComponent } from './common/components/history/history.component';
import { ReleaseFormOriginalComponent } from './entities/release-original/release-form/release-form.component';
import { EORewardsTrackDynamicFieldComponent } from './cms-v2/entities/endless-offer-track/components/eo-rewards-track-dynamic-field/eo-rewards-track-dynamic-field.component';
import { StoreListingFormV2Component } from './cms-v2/entities/store-listing/components/store-listing-form-v2/store-listing-form-v2.component';
import { StoreListingViewV2Component } from './cms-v2/entities/store-listing/components/store-listing-view-v2/store-listing-view-v2.component';
import { BundleAssetViewComponent } from './entities/bundle-asset-view/bundle-asset-view.component';
import { BundleViewTableComponent } from './entities/bundle-asset-view/bundle-view-table/bundle-view-table.component';
import { AgGridTableComponent } from './common/ag-grid-table/ag-grid-table.component';
import { AiTableSearchModule } from './common/ag-grid-table/components/ai-table-search/ai-table-search.module';
import { AiTagsPanelModule } from './common/components/ai-tags-panel/ai-tags-panel.module';
import { FlashBackChallengeTableAgGridComponent } from './cms-v2/entities/challenge/components/flashback-challenge-table-ag-grid/challenge-table-ag-grid.component';
import { NufCollectionTableAgGridComponent } from './entities/nuf-collection/nuf-collection-table-ag-grid/nuf-collection-table-ag-grid.component';
import { AssetBundleTableAgGridComponent } from './cms-v2/entities/asset-bundle-table-ag-grid/asset-bundle-table-ag-grid.component';
import { LocalizedStringsTableAgGridComponent } from './cms-v2/entities/localized-strings/components/localized-strings/localized-strings-ag-grid.component';
import { ClientStringsTableAgGridComponent } from './cms-v2/entities/client-strings/components/client-strings/client-strings-ag-grid.component';
import { ThumbnailCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/thumbnail/thumbnail.component';
import { TextCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/text/text.component';
import { AsyncTextCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/async-text/async-text.component';
import { ActionsCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/actions/actions.component';
import { RefsCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/refs/refs.component';
import { RefCountCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/ref-count/ref-count.component';
import { BuildStatusCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/build-status/build-status.component';
import { LineItemCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/line-item/line-item.component';
import { MiscAssetCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/misc-asset/misc-asset.component';
import { EOTrackCellRenderer } from './common/ag-grid-table/cell-renderers/render-components/eo-track/eo-track.component';
import { LinkCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/link/link.component';
import { RichTextCellRendererComponent } from './common/ag-grid-table/cell-renderers/render-components/rich-text/rich-text.component';
import { ChartCellRendererComponent, ChartDetailDialogComponent } from './common/ag-grid-table/cell-renderers/render-components/chart-cell-renderer/chart-cell-renderer.component';
import { IncludeExcludeFilterComponent } from './common/ag-grid-table/filters/include-exclude-filter.component';
import { ColumnPresetsComponent } from './common/ag-grid-table/sidebar-components/column-presets/column-presets.component';
import { CmsFiltersComponent } from './common/ag-grid-table/sidebar-components/cms-filters/cms-filters.component';
import { CalendarEditorComponent } from './common/ag-grid-table/cell-editors/calendar/calendar.component';
import { BooleanEditorComponent } from './common/ag-grid-table/cell-editors/boolean/boolean.component';
import { DropdownEditorComponent } from './common/ag-grid-table/cell-editors/dropdown/dropdown.component';
import { MultiselectEditorComponent } from './common/ag-grid-table/cell-editors/multiselect/multiselect.component';
import { AutocompleteEditorComponent } from './common/ag-grid-table/cell-editors/autocomplete/autocomplete.component';
import { LineItemEditorComponent } from './common/ag-grid-table/cell-editors/line-item/line-item.component';
import { RichTextEditorComponent } from './common/ag-grid-table/cell-editors/rich-text/rich-text.component';
import { LinkCellEditorComponent } from './common/ag-grid-table/cell-editors/link/link.component';
import { ColorTextComponent } from './common/ag-grid-table/cell-editors/color-text/color-text.component';
import { AgTableActionsComponent } from './common/ag-grid-table/ag-grid-actions/ag-grid-actions.component';
import { MainStatusPanelComponent } from './common/ag-grid-table/ag-grid-status-panels/main-panel/main-status-panel.component';
import { BulkEditInputComponent } from './common/ag-grid-table/ag-grid-actions/bulk-edit-input/bulk-edit-input.component';
import { EndlessOfferTrackComponent } from './common/components/dynamic-view-v2/components/endless-offer-track/endless-offer-track/endless-offer-track.component';
import { EndlessOfferTrackComponentV2 } from './common/components/dynamic-view-v2/components/endless-offer-track/endless-offer-track-v2/endless-offer-track-v2.component';
import { MiscImageRecordV2Component } from './common/components/dynamic-view-v2/components/misc-image-record-v2/misc-image-record-v2.component';
import { ColorPickerFieldComponent } from './common/components/dynamic-view-v2/components/color-picker-field/color-picker-field.component';
import { NurtureStagesFieldComponent } from './common/components/dynamic-view-v2/components/nurture-stages-field/nurture-stages-field.component';
import { InputPriceComponent } from './common/components/dynamic-view-v2/components/input-price/input-price.component';
import { MiscRefComponent } from './common/components/dynamic-view-v2/components/misc-ref/misc-ref.component';
import { LocalizationKeyStatusComponent } from './common/components/dynamic-view-v2/components/localization-key-status/localization-key-status.component';
import { ThumbnailStyleComponent } from './common/components/dynamic-view-v2/components/thumbnail-style/thumbnail-style.component';
import { DisplayThumbnailComponent } from './common/components/dynamic-view-v2/components/display-thumbnail/display-thumbnail.component';
import { DisplayBuildStatusComponent } from './common/components/dynamic-view-v2/components/display-build-status/display-build-status.component';
import { AutocompleteComponent } from './common/components/dynamic-view-v2/components/autocomplete/autocomplete.component';
import { RenderThumbnailsComponent } from './common/components/dynamic-view-v2/components/render-thumbnails/render-thumbnails.component';
import { BuildStatusComponent } from './common/components/dynamic-view-v2/components/build-status/build-status.component';
import { MiscImageBuildComponentComponent } from './common/components/dynamic-view-v2/components/misc-image-build-component/misc-image-build-component.component';
import { MiscImageArrayBuild } from './common/components/dynamic-view-v2/components/misc-image-array-build/misc-image-array-build.component';
import { NestedInputComponent } from './common/components/nested-input/nested-input.component';
import { GoalImageComponentComponent } from './common/components/goal-image-component/goal-image-component.component';
import { SideThumbnailComponent } from './common/components/dynamic-view-v2/components/side-thumbnail/side-thumbnail.component';
import { GoalImageryComponent } from './common/components/dynamic-view-v2/components/goal-imagery/goal-imagery.component';
import { NestedInputViewComponent } from './common/components/dynamic-view-v2/components/nested-input-view/nested-input-view.component';
import { MysteryBoxContentListComponent } from './common/components/dynamic-view-v2/components/mystery-box-content-list/mystery-box-content-list.component';
import { ReadonlyFieldComponent } from './common/components/readonly-field/readonly-field.component';
import { EmbeddedFormComponent } from './common/components/dynamic-form-v2/components/embedded-form/embedded-form.component';
import { BooleanViewComponent } from './common/components/dynamic-view-v2/components/Boolean/boolean.component';
import { FilterRulesComponent } from './common/components/dynamic-view-v2/components/filter-rules/filter-rules.component';
import { AgGridTableViewComponent } from './common/components/dynamic-view-v2/components/ag-grid-table-view/ag-grid-table-view.component';
import { GridViewComponent } from './common/components/grid-view/grid-view.component';
import { BaseViewFieldComponent } from './common/components/base-view-field/base-view-field.component';
import { NestedListContentComponent } from './common/components/base-view-field/nested-list-content/nested-list-content.component';
import { GridViewSettingsComponent } from './common/ag-grid-table/sidebar-components/grid-view-settings/grid-view-settings.component';
import { CardComponent } from './common/components/grid-view/card-component/card-component';
import { CategoryIconComponent } from './cms-v2/entities/category/components/category-icon/category-icon.component';
import { CategoryClimateIconComponent } from './cms-v2/entities/category/components/category-climate-icon/category-climate-icon.component';
import { StoreTransferComponent } from './cms-v2/entities/store-listing/components/store-transfer/store-transfer.component';
import { DataComponentComponent } from './cms-v2/entities/store-listing/components/store-transfer/data-component/data-component.component';
import { EnvironmentTogglerComponent } from './common/components/environment-toggler/environment-toggler.component';
import { StoregamedataviewComponent } from './cms-v2/store/store-game-data/storegamedataview/storegamedataview.component';
import { ThumbnailComponent } from './common/components/thumbnail-component/thumbnail.component';
import { TableInputComponent } from './common/components/dynamic-form-v2/components/table-input/table-input.component';
import { LineBreakPipe } from './line-break.pipe';
import { LocalizationConfigurationViewComponent } from './cms-v2/entities/localization/localization-config-view/localization-configuration-view/localization-configuration-view.component';
import { LocalizationConfigurationTableComponent } from './cms-v2/entities/localization/localization-config-view/localization-configuration-view/localization-configuration-table/localization-configuration-table/localization-configuration-table.component';
import { LocalizationConfigFormComponent } from './cms-v2/entities/localization/form/localization-config-form-component/localization-config-form-component';
import { SideMenuComponent } from './common/ag-grid-table/sidebar-components/side-menu/side-menu.component';
import { StringPopupFormComponent } from './common/components/string-popup-form/string-popup-form.component';
import { CustomactionbuttonComponent } from './common/components/customactionbutton/customactionbutton.component';
import { SponsorViewV2Component } from './cms-v2/sponsor/sponsor-view-v2/sponsor-view-v2.component';
import { SponsorFormV2Component } from './cms-v2/sponsor/sponsor-form-v2/sponsor-form-v2.component';
import { SponsorTableAgGridComponent } from './cms-v2/sponsor/sponsor-table-ag-grid/sponsor-table-ag-grid.component';
import { ItemSetGeneratorPopupComponent } from './common/components/dynamic-form-v2/components/item-set-generator-popup/item-set-generator-popup.component';
import { InGamePreviewComponent } from './common/components/dynamic-form-v2/components/in-game-preview/in-game-preview.component';
import { InsertImagePipe } from './common/pipes/insert-image.pipe';
import { BuildGamedataV3Component } from './build-gamedata/build-gamedata-v3/build-gamedata-v3/build-gamedata-v3.component';
import { GameDataLogsPopupComponent } from './build-data/gamedata-logs-popup/game-data-logs-popup/game-data-logs-popup.component';
import { BuildGamedataV3ViewComponent } from './build-gamedata/build-gamedata-v3-view/build-gamedata-v3-view.component';
import { EntityDisplayComponent } from './entities/item/entity-display/entity-display.component';
import { FieldDisplayComponent } from './entities/item/field-display/field-display.component';
import { ImageDialogComponent } from './entities/item/image-dialog/image-dialog.component';
import { LocalizedTableComponent } from './entities/challenge/localized-table/localized-table.component';
import { DuplicationDialogComponent } from './entities/challenge/duplication-dialog/duplication-dialog.component';
import { EntityHeaderComponent } from './entities/challenge/entity-header/entity-header.component';
import { ChallengeImagePopupComponent } from './entities/challenge/challenge-image-popup/challenge-image-popup.component';
import { ExpandObjectPipe } from './common/pipes/expand-object.pipe';
import { ChallengeCollectionCustomFieldComponent } from './cms-v2/entities/challenge-collection/components/challenge-collection-custom-field/challenge-collection-custom-field.component';
import { KeywordsViewV2Component } from './cms-v2/entities/keywords/keywords-view-v2/keywords-view-v2.component';
import { DiffToolViewComponent } from './entities/diff-tool-view/diff-tool-view.component';
import { JobRecordsTableComponent } from './common/components/job-records-table/job-records-table.component';
import { DiffToolAgAgridComponent } from './entities/diff-tool-ag-agrid/diff-tool-ag-agrid.component';
import { RewardCardComponent } from './cms-v2/entities/rewards-track/components/reward-card/reward-card.component';
import { RoleComponent } from './role/role.component';
import { RoleFormDialogComponent } from './role/role-form-dialog/role-form-dialog.component';
import { PermissionViewDialogComponent } from './role/permission-view-dialog/permission-view-dialog.component';
import { UserComponent } from './user/user.component';
import { TeamComponent } from './team/team.component';
import { NotesPopupComponent } from './common/components/dynamic-view-v2/components/notes-popup-component/notes-popup.component';
import { RoleViewDialogComponent } from './user/role-view-dialog/role-view-dialog.component';
import { PermissionFormDialogComponent } from './permissions/permission-form-dialog/permission-form-dialog.component';
import { ReleaseProgressionLevelsV2Component } from './entities/release/release-progression-levels-v2/release-progression-levels-v2.component';
import { ReleaseNurtureCollectionComponent } from './entities/release/release-nurture-collection/release-nurture-collection/release-nurture-collection.component';
import { JsonMetadataViewerComponent } from './cms-v2/entities/automation-log/components/json-metadata-viewer/json-metadata-viewer.component';
import { DynamicEntityFormComponentComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-form-component/dynamic-entity-form-component.component';
import { DynamicEntityViewComponentComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-view-component/dynamic-entity-view-component.component';
import { MetadataFormComponent } from './common/components/dynamic-form-v2/components/metadata-form/metadata-form.component';
import { ReleaseGardenPassComponent } from './entities/release/release-garden-pass/release-garden-pass/release-garden-pass.component';
import { RewardtimelineComponent } from './cms-v2/entities/rewards-track/components/rewardtimeline/rewardtimeline.component';
import { SeasonalPrizesViewV2Component } from './cms-v2/entities/seasonal-prizes/seasonal-prizes-view-v2/seasonal-prizes-view-v2/seasonal-prizes-view-v2.component';
import { SeasonalPrizesFormV2Component } from './cms-v2/entities/seasonal-prizes/seasonal-prizes-form-v2/seasonal-prizes-form-v2/seasonal-prizes-form-v2.component';
import { SeasonalPrizesAgGridComponent } from './cms-v2/entities/seasonal-prizes/seasonal-prizes-ag-grid/seasonal-prizes-ag-grid/seasonal-prizes-ag-grid.component';
import { ProdPushInfoComponent } from './entities/settings/components/prod-push-info/prod-push-info.component';
import { MiscAssetBuildErrorLogsComponent } from './common/components/dynamic-view-v2/components/misc-asset-build-error-logs/misc-asset-build-error-logs.component';
import { RewardsTrackInputComponent } from './cms-v2/entities/rewards-track/components/rewards-track-input-component/rewards-track-input.component';
import { ScheduleDetailTemplateComponent } from './common/ag-grid-table/ag-grid-schedule-table/schedule-detail-template/schedule-detail-template.component';
import { DynamicEntityHistoryComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-history/dynamic-entity-history.component';
import { DynamicEntityTableComponent } from './common/components/dynamic-form-v2/components/dynamic-entity-table-component/dynamic-entity-table.component';
import { EntityTableComponent } from './common/components/dynamic-form-v2/components/entity-table-component/entity-table.component';
import { DupDialogComponent } from './common/components/dup-dialog/dup-dialog.component';
import { DupDialogRowComponent } from './common/components/dup-dialog/dup-dialog-row/dup-dialog-row.component';
import { ReportIssueComponent } from './common/components/report-issue/report-issue.component';
import { ContentIssuesComponent } from './cms-v2/content-issues/content-issues.component';
import { UsersAndSecurityComponent } from './entities/settings/tabs/users-and-security/users-and-security/users-and-security.component';
import { AppApiKeysComponent } from './entities/settings/components/app-api-keys/app-api-keys.component';
import { ManagedListsComponent } from './entities/settings/tabs/managed-lists/managed-lists/managed-lists.component';
import { DataManagementComponent } from './entities/settings/tabs/data-management/data-management.component';
import { ScheduleSidebarComponent } from './common/ag-grid-table/ag-grid-schedule-table/schedule-sidebar/schedule-sidebar.component';
import { DynamicEntitiesComponent } from './entities/settings/tabs/dynamic-entities/dynamic-entities/dynamic-entities.component';
import { RewardTimelineComponent } from './cms-v2/entities/rewards-track/components/reward-timeline/reward-timeline.component';
import { DynamicListTableComponent } from './common/components/dynamic-list-table/dynamic-list-table.component';
import { DynamicDialogFormComponent } from './common/components/dynamic-dialog-form/dynamic-dialog-form.component';
import { MobileBuildStatusComponent } from './entities/item/components/mobile-build-status/mobile-build-status.component';
import { LocalizedValuesDialogComponent } from './entities/item/localized-values-dialog/localized-values-dialog.component';
import { MetadataViewComponent } from './common/components/dynamic-view-v2/components/metadata-view/metadata-view.component';
import { AgGridBaseTableComponent } from './common/ag-grid-base-table/ag-grid-base-table.component';
import { BaseDialogComponent } from './common/components/base-dialog/base-dialog.component';
import { RequestTranslationButtonComponent } from './common/components/request-translation-button/request-translation-button.component';
import { LocalizationTableComponent } from './localization/localization-table/localization-table.component';
import { LocalizationIndexComponent } from './localization/localization-index/localization-index.component';
import { ItemSetsToolPanelComponent } from './common/ag-grid-table/sidebar-components/item-sets-tool-panel/item-sets-tool-panel.component';
import { ItemSetSelectorDialogComponent } from './common/ag-grid-table/sidebar-components/item-sets-tool-panel/item-set-selector-dialog/item-set-selector-dialog.component';
import { NewSetDialogComponent } from './common/ag-grid-table/sidebar-components/item-sets-tool-panel/new-set-dialog/new-set-dialog.component';
import { GamedataDownloadDialogComponent } from './build-gamedata/components/gamedata-download-dialog/gamedata-download-dialog.component';
import { FilterSectionPlaceholderComponent } from './cms-v2/entities/item/components/prizes-automator/filter-section-placeholder/filter-section-placeholder.component';
import { PrizeWeightsFilterComponent } from './cms-v2/entities/item/components/prizes-automator/prize-weights-filter/prize-weights-filter.component';
import { PrizeDateFilterComponent } from './cms-v2/entities/item/components/prizes-automator/prize-date-filter/prize-date-filter.component';
import { PrizeTagFilterComponent } from './cms-v2/entities/item/components/prizes-automator/prize-tag-filter/prize-tag-filter.component';
import { FiltersDrawerComponent } from './cms-v2/entities/item/components/prizes-automator/filters-drawer/filters-drawer.component';
import { ColorTagStepperComponent } from './cms-v2/entities/item/components/color-tag-stepper/color-tag-stepper.component';
import { RewardTrackTemplateAgGridComponent } from './cms-v2/entities/reward-track-templates/components/reward-track-template-ag-grid/reward-track-template-ag-grid.component';
import { ScheduleTypeTableAgGridComponent } from './cms-v2/entities/schedule-type/components/schedule-type-table-ag-grid/schedule-type-table-ag-grid.component';
import { ScheduleTypeFormV2Component } from './cms-v2/entities/schedule-type/components/schedule-form-v2/schedule-type-form-v2.component';
import { ScheduleTypeViewV2Component } from './cms-v2/entities/schedule-type/components/schedule-type-view-v2/schedule-type-view-v2.component';
import { QAUserGroupsFormsV2Component } from './cms-v2/entities/qa-user-groups/qa-user-groups-forms-v2/qa-user-groups-forms-v2.component';
import { QaUserGroupsAgGridComponent } from './cms-v2/entities/qa-user-groups/qa-user-groups-ag-grid/qa-user-groups-ag-grid.component';
import { QAUserGroupsViewV2Component } from './cms-v2/entities/qa-user-groups/qa-user-groups-views-v2/qa-user-groups-views-v2.component';
import { QAUsersAgGridComponent } from './cms-v2/entities/qa-users/qa-users-ag-grid/qa-users-ag-grid.component';
import { QAUsersFormV3Component } from './cms-v2/entities/qa-users/qa-users-form-v3/qa-users-form-v3.component';
import { QAUsersViewsV2Component } from './cms-v2/entities/qa-users/qa-users-views-v2/qa-users-views-v2.component';
import { HashCompareDisplayComponent } from './entities/item/components/build-data-card/hash-compare-display.component';
import { RewardTrackTemplateFormV2Component } from './cms-v2/entities/reward-track-templates/components/reward-track-template-form-v2/reward-track-template-form-v2.component';
import { RewardTrackTemplateViewV2Component } from './cms-v2/entities/reward-track-templates/components/reward-track-template-view-v2/reward-track-template-view-v2.component';
import { BuilderComponent } from './entities/settings/tabs/builder/builder.component';
import { LocalizationSyncComponent } from './entities/settings/tabs/localization-sync/localization-sync.component';
import { NotificationSettingsComponent } from './entities/settings/tabs/notifications/notification-settings.component';
import { DynamicMysteryBoxFormComponent } from './cms-v2/entities/dynamic-mystery-box/dynamic-mystery-box-form/dynamic-mystery-box-form.component';
import { DynamicMysteryBoxViewComponent } from './cms-v2/entities/dynamic-mystery-box/dynamic-mystery-box-view/dynamic-mystery-box-view.component';
import { DynamicMysteryBoxTableAgGridComponent } from './cms-v2/entities/dynamic-mystery-box/dynamic-mystery-box-table-ag-grid/dynamic-mystery-box-table-ag-grid.component';
import { MysteryBoxContentFormComponent } from './cms-v2/entities/mystery-box-content/mystery-box-content-form/mystery-box-content-form.component';
import { MysteryBoxContentViewComponent } from './cms-v2/entities/mystery-box-content/mystery-box-content-view/mystery-box-content-view.component';
import { MysteryBoxContentTableAgGridComponent } from './cms-v2/entities/mystery-box-content/mystery-box-content-table-ag-grid/mystery-box-content-table-ag-grid.component';
import { NotificationBellComponent } from './common/components/notification-bell/notification-bell.component';
import { NotificationCenterComponent } from './notifications/notification-center.component';
import { ActivityTrackerComponent } from './activity-tracker/activity-tracker.component';
import { ActivityLogEntityLinkCellRendererComponent } from './activity-tracker/activity-log-entity-link-cell-renderer/activity-log-entity-link-cell-renderer.component';
import { FavoriteToggleComponent } from './common/components/favorite-toggle/favorite-toggle.component';

const SHARED_MODULES = [
  AutoCompleteModule,
  AccordionModule,
  BadgeModule,
  ButtonModule,
  CommonModule,
  CalendarModule,
  CardModule,
  ProgressSpinnerModule,
  CheckboxModule,
  ChipModule,
  ColorPickerModule,
  DialogModule,
  GalleriaModule,
  DividerModule,
  DropdownModule,
  FieldsetModule,
  FormsModule,
  InplaceModule,
  InputNumberModule,
  InputSwitchModule,
  InputTextModule,
  InputTextareaModule,
  ListboxModule,
  MenubarModule,
  MessageModule,
  MessagesModule,
  MultiSelectModule,
  NgxChartsModule,
  NgChartsModule,
  ScrollPanelModule,
  OverlayPanelModule,
  PanelModule,
  PickListModule,
  RadioButtonModule,
  ReactiveFormsModule,
  RippleModule,
  SelectButtonModule,
  StepsModule,
  SidebarModule,
  SkeletonModule,
  TableModule,
  TabViewModule,
  TagModule,
  TriStateCheckboxModule,
  ImageModule,
  ToolbarModule,
  OrderListModule,
  ToastModule,
  ToggleButtonModule,
  TooltipModule,
  ChipsModule,
  FileUploadModule,
  RouterModule,
  DynamicDialogModule,
  ConfirmDialogModule,
  PasswordModule,
  ProgressBarModule,
  SplitterModule,
  DragDropModule,
  NgxSpinnerModule,
  TimelineModule,
  TreeModule,
  EditorModule,
  DataViewModule,
  PaginatorModule,
  LazyLoadImageModule,
  AgGridModule,
  PanelMenuModule,
  AiTableSearchModule,
  AiTagsPanelModule,
];

const SHARED_DECLARATIONS = [
  AuthComponent,
  BaseInputFieldComponent2,
  BaseviewComponent,
  YesNoPipe,
  ThumbPathPipe,
  OfficeTimePipe,
  ConvertToReadablePipe,
  OfficeTimeFormPipe,
  Safe,
  BuildAssetComponent,
  ManagedListComponent,
  DynamicFormComponent,
  DynamicFieldComponent,
  DependentInputComponent,
  FormArrayComponent,
  FormGroupComponent,
  ItemBuildsHistoryComponent,
  ChallengeBuildsHistoryComponent,
  FormCreatorComponent,
  RefSuffixRemovalPipe,
  CurrencyFormComponent,
  BuildGamedataComponent,
  TraitTableComponent,
  ArtComponent,
  RenameContentComponent,
  CollectionViewComponent,
  BuildDataComponent,
  SettingsComponent,
  TableDataComponent,
  FileUplaoderComponent,
  EntityHistoryComponent,
  PermissionsComponent,
  RulesComponent,
  GamedataDiffViewComponent,
  GamedataDiffViewV2Component,
  GamedataCompareToolComponent,
  ProdGamedataPushComponent,
  ChallengesKeywordsComponent,
  PrizesCardFormGroupComponent,
  GlobalSearchComponent,
  DropdownMultiselectComponent,
  AdvancedSearchComponent,
  BuildNodesSettingsComponent,
  CmsDevSettingsComponent,
  NestedEconTableComponent,
  EconTableComponent,
  BulkBuildDataComponent,
  BulkBuildDataTableComponent,
  DynamicFormV2Component,
  BaseDynamicFormComponent,
  MultiDropdownSelectComponent,
  IconsViewComponent,
  SeasonPassViewComponent,
  SeasonPassTracksFieldComponent,
  RewardsTrackFormV3Component,
  RewardsTrackDynamicFieldComponent,
  RewardsTrackViewComponent,
  RestrictionFormFieldComponent,
  CollectionCustomFieldComponent,
  DailyRewardsDynamicFieldComponent,
  SeasonPassFormTracksCustomFieldComponent,
  LoadingScreenImagesComponent,
  AssetVersionTableComponent,
  DynamicViewV2,
  ValidateButtonComponent,
  ValidationResultsPanelComponent,
  ValidateEntityComponent,
  PlasticFilesAutocompleteComponent,
  TagsManagedListComponent,
  ContentHoldManagedListComponent,
  ChallengeContentHoldManagedListComponent,
  CreatureTypeVariantsInlineComponent,
  DailyRewardsThemeAssetByDayComponent,
  DailyGoalDateToAchievementComponent,
  DailyGoalDateToAchievementsComponent,
  QuestionsInlineComponent,
  QuestionsBulkImportComponent,
  AnswersBulkImportComponent,
  CollectionsBulkImportComponent,
  AnimationTriggerMapInputComponent,
  AnimationTriggerMapViewComponent,
  NurtureCustomFieldComponent,
  RenderPreviewToolComponent,
  NufCollectionViewComponent,
  CreateNewAssetComponent,
  BulkRenderAssetsComponent,
  BuildHistoryChartComponent,
  ReleaseTypeCustomFieldComponent,
  BuildHistoryComponent,
  AssetPopupFormComponent,
  DynamicListComponent,
  RenderGalleryComponent,
  AssetRefInputComponent,
  NurtureItemsInputComponentComponent,
  NurtureStagesInputComponent,
  HistoryComponent,
  ReleaseFormOriginalComponent,
  EORewardsTrackDynamicFieldComponent,
  StoreListingFormV2Component,
  StoreListingViewV2Component,
  BundleAssetViewComponent,
  BundleViewTableComponent,
  AgGridTableComponent,
  FlashBackChallengeTableAgGridComponent,
  NufCollectionTableAgGridComponent,
  AssetBundleTableAgGridComponent,
  LocalizedStringsTableAgGridComponent,
  ClientStringsTableAgGridComponent,
  ThumbnailCellRendererComponent,
  TextCellRendererComponent,
  AsyncTextCellRendererComponent,
  ActionsCellRendererComponent,
  RefsCellRendererComponent,
  RefCountCellRendererComponent,
  BuildStatusCellRendererComponent,
  LineItemCellRendererComponent,
  MiscAssetCellRendererComponent,
  EOTrackCellRenderer,
  LinkCellRendererComponent,
  RichTextCellRendererComponent,
  ChartCellRendererComponent,
  ChartDetailDialogComponent,
  IncludeExcludeFilterComponent,
  ColumnPresetsComponent,
  CmsFiltersComponent,
  CalendarEditorComponent,
  BooleanEditorComponent,
  DropdownEditorComponent,
  MultiselectEditorComponent,
  AutocompleteEditorComponent,
  LineItemEditorComponent,
  RichTextEditorComponent,
  LinkCellEditorComponent,
  ColorTextComponent,
  AgTableActionsComponent,
  MainStatusPanelComponent,
  BulkEditInputComponent,
  EndlessOfferTrackComponent,
  EndlessOfferTrackComponentV2,
  MiscImageRecordV2Component,
  ColorPickerFieldComponent,
  NurtureStagesFieldComponent,
  InputPriceComponent,
  MiscRefComponent,
  LocalizationKeyStatusComponent,
  ThumbnailStyleComponent,
  DisplayThumbnailComponent,
  DisplayBuildStatusComponent,
  AutocompleteComponent,
  RenderThumbnailsComponent,
  BuildStatusComponent,
  MiscImageBuildComponentComponent,
  MiscImageArrayBuild,
  NestedInputComponent,
  GoalImageComponentComponent,
  SideThumbnailComponent,
  GoalImageryComponent,
  NestedInputViewComponent,
  MysteryBoxContentListComponent,
  ReadonlyFieldComponent,
  EmbeddedFormComponent,
  BooleanViewComponent,
  FilterRulesComponent,
  AgGridTableViewComponent,
  GridViewComponent,
  BaseViewFieldComponent,
  NestedListContentComponent,
  GridViewSettingsComponent,
  CardComponent,
  CategoryIconComponent,
  CategoryClimateIconComponent,
  StoreTransferComponent,
  DataComponentComponent,
  EnvironmentTogglerComponent,
  StoregamedataviewComponent,
  ThumbnailComponent,
  TableInputComponent,
  LineBreakPipe,
  LocalizationConfigurationViewComponent,
  LocalizationConfigurationTableComponent,
  LocalizationConfigFormComponent,
  SideMenuComponent,
  StringPopupFormComponent,
  CustomactionbuttonComponent,
  SponsorViewV2Component,
  SponsorFormV2Component,
  SponsorTableAgGridComponent,
  ItemSetGeneratorPopupComponent,
  InGamePreviewComponent,
  InsertImagePipe,
  BuildGamedataV3Component,
  GameDataLogsPopupComponent,
  BuildGamedataV3ViewComponent,
  EntityDisplayComponent,
  FieldDisplayComponent,
  ImageDialogComponent,
  LocalizedTableComponent,
  DuplicationDialogComponent,
  EntityHeaderComponent,
  ChallengeImagePopupComponent,
  ExpandObjectPipe,
  ChallengeCollectionCustomFieldComponent,
  KeywordsViewV2Component,
  DiffToolViewComponent,
  JobRecordsTableComponent,
  DiffToolAgAgridComponent,
  RewardCardComponent,
  RoleComponent,
  RoleFormDialogComponent,
  PermissionViewDialogComponent,
  UserComponent,
  TeamComponent,
  NotesPopupComponent,
  RoleViewDialogComponent,
  PermissionFormDialogComponent,
  ReleaseProgressionLevelsV2Component,
  ReleaseNurtureCollectionComponent,
  JsonMetadataViewerComponent,
  DynamicEntityFormComponentComponent,
  DynamicEntityViewComponentComponent,
  MetadataFormComponent,
  ReleaseGardenPassComponent,
  RewardtimelineComponent,
  SeasonalPrizesViewV2Component,
  SeasonalPrizesFormV2Component,
  SeasonalPrizesAgGridComponent,
  ProdPushInfoComponent,
  MiscAssetBuildErrorLogsComponent,
  RewardsTrackInputComponent,
  ScheduleDetailTemplateComponent,
  DynamicEntityHistoryComponent,
  DynamicEntityTableComponent,
  EntityTableComponent,
  DupDialogComponent,
  DupDialogRowComponent,
  ReportIssueComponent,
  ContentIssuesComponent,
  UsersAndSecurityComponent,
  AppApiKeysComponent,
  ManagedListsComponent,
  DataManagementComponent,
  ScheduleSidebarComponent,
  DynamicEntitiesComponent,
  RewardTimelineComponent,
  DynamicListTableComponent,
  DynamicDialogFormComponent,
  MobileBuildStatusComponent,
  LocalizedValuesDialogComponent,
  MetadataViewComponent,
  AgGridBaseTableComponent,
  BaseDialogComponent,
  RequestTranslationButtonComponent,
  LocalizationTableComponent,
  LocalizationIndexComponent,
  ItemSetsToolPanelComponent,
  ItemSetSelectorDialogComponent,
  NewSetDialogComponent,
  GamedataDownloadDialogComponent,
  FilterSectionPlaceholderComponent,
  PrizeWeightsFilterComponent,
  PrizeDateFilterComponent,
  PrizeTagFilterComponent,
  FiltersDrawerComponent,
  ColorTagStepperComponent,
  RewardTrackTemplateAgGridComponent,
  ScheduleTypeTableAgGridComponent,
  ScheduleTypeFormV2Component,
  ScheduleTypeViewV2Component,
  QAUserGroupsFormsV2Component,
  QaUserGroupsAgGridComponent,
  QAUserGroupsViewV2Component,
  QAUsersAgGridComponent,
  QAUsersFormV3Component,
  QAUsersViewsV2Component,
  HashCompareDisplayComponent,
  RewardTrackTemplateFormV2Component,
  RewardTrackTemplateViewV2Component,
  BuilderComponent,
  LocalizationSyncComponent,
  NotificationSettingsComponent,
  DynamicMysteryBoxFormComponent,
  DynamicMysteryBoxViewComponent,
  DynamicMysteryBoxTableAgGridComponent,
  MysteryBoxContentFormComponent,
  MysteryBoxContentViewComponent,
  MysteryBoxContentTableAgGridComponent,
  NotificationBellComponent,
  NotificationCenterComponent,
  ActivityTrackerComponent,
  ActivityLogEntityLinkCellRendererComponent,
  FavoriteToggleComponent,
];

/**
 * Everything the app shell and the lazy feature modules have in common.
 *
 * Holds every component, pipe and directive that is used by the shell, by the routes that are
 * still eager (app-routing.module.ts, auth, dashboard) or by more than one lazy feature, and
 * re-exports the third-party modules their templates rely on. Lazy feature modules under
 * routes/lazy/ import this module instead of listing PrimeNG/AgGrid pieces themselves.
 *
 * Must not import anything that registers app-wide providers (HttpClientModule,
 * SocialLoginModule, BrowserModule...): lazy modules re-import this module into their own
 * injector, so those providers would be duplicated there. Keep them in AppModule.
 */
@NgModule({
  declarations: SHARED_DECLARATIONS,
  imports: SHARED_MODULES,
  exports: [...SHARED_MODULES, ...SHARED_DECLARATIONS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppSharedModule {}
